import { render, staticRenderFns } from "./TicketsCreatedList.vue?vue&type=template&id=2d523a7e"
import script from "./TicketsCreatedList.vue?vue&type=script&lang=js"
export * from "./TicketsCreatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports